<template>
    <!-- <v-container class='containerPage'> -->
    <container-page :headerHeight="'25%'" :bodyHeight="'89%'" class="header-customized">
        <template v-slot:header>
            <div class="headerItemsResponsive" v-if="!user.CLIENTE_ID">
                <span class="titlePage">{{'Pedidos' | translate('Pedidos')}}</span>
                <div class="headerbuttons">
                    <v-spacer></v-spacer>            
                </div>
            </div>
            <v-tabs
                id="tabsElement"
                height="60px"
                class="headerTabs"
                color="black"
                slider-size="4" 
                v-if="situations.length && !user.CLIENTE_ID" 
                v-model="tab"
                show-arrows
                v-resize="onResize"
            >
                <v-tab class="PedidosTab" v-for="(situation, i) in situations" 
                    :key="i" 
                    :id="situation.CODIGO?'/pedidos/'+situation.CODIGO : '/pedidos'"  
                    @click="changeRouter(situation)"
                >
                    <div class=tabStyle>
                        <div class="tab">
                            <div class="badge" v-if="situation.noViews">
                                <span>{{situation.noViews}}</span>
                            </div>
                            <span class="tabFont">{{situation.NOME | translate('Pedidos')}}</span>
                        </div>
                        <span class="tabFont">{{situation.QTD}}</span>
                    </div>
                </v-tab>
            </v-tabs>
            <div id="borderBottomTabs" class="borderBottomTabs" v-if="!user.CLIENTE_ID"/>
        </template>
        <template v-slot:body  v-if="!user.CLIENTE_ID">
            <div class="divTabs">
                <v-tabs-items v-model="tab" style="height:100%;">
                    <v-tab-item v-for="(situation, i) in situations" :key="i" style="height:100%;">
                        <router-view />
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
        <div v-if="user.CLIENTE_ID">
            <no-adm-banner message="Área destinada a usuários Operadores!"/>
        </div>
    </container-page>
</template>

<script>
import translate from '../../../src/plugins/translate'
import getAllOrderSituations from '../../../src/app/situacaoPedido/getAllOrderSituations'
import ContainerPage from '../../../src/components/containerPage.vue'
import { createNamespacedHelpers } from 'vuex'
import NoAdmBanner from '../../../src/components/NoAdmBanner.vue'

const user = createNamespacedHelpers('user')

export default {
    name: 'Pedidos',
    components: {ContainerPage, NoAdmBanner},
    data() {
        return {
            tab:null,
            loading: false,
            search: null,
            situations: [],
            labels: {
                textLoading: translate('Carregando Pedidos', 'Pedidos'),
                textNoData: translate('Nenhum registro localizado', 'Pedidos')
            },
            imageTime: new Date().getTime(),
        }
    },
    watch:{
        $route (to){
            this.$nextTick(function(){
                let el = document.getElementById(to.path)
                el.click()
            })
        }
    },
    computed:{
        ...user.mapGetters(['user']) 
    },
    methods: {
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.setWidthBordersTabs()
        },
        async getAllSituations() {
            this.loading = true

            await getAllOrderSituations({companyId:this.user.EMPRESA_ID, active:'S', userId:this.user.USUARIO_ID, isAdmin : this.user.ADM})
                .then(function(response){
                    this.situations = response.data
                    this.setWidthBordersTabs()
                }.bind(this))
                .finally(this.loading = false)
        },
        setWidthBordersTabs(){
            setTimeout(function(){
                var divTabs = document.getElementById('tabsElement')
                var tabsBorder = document.getElementById('borderBottomTabs')
                var allTabs = document.getElementsByClassName('PedidosTab')
                if(divTabs && tabsBorder.offsetWidth < divTabs.offsetWidth) {
                    var widthBorderBoddom = 0
                    allTabs.forEach(function(tab){
                        widthBorderBoddom += tab.offsetWidth
                    })
                    let element = document.getElementById('borderBottomTabs')
                    element.style.width = `${widthBorderBoddom}px`
                } else if(tabsBorder) tabsBorder.style.width = divTabs ?`${divTabs.offsetWidth}px` : tabsBorder.style.width
            },600)
        },
        changeRouter(situation){
            if(window.location.pathname != (situation.CODIGO ? '/pedidos/'+ situation.CODIGO : '/pedidos') ) this.$router.push(situation.CODIGO ? '/pedidos/'+situation.CODIGO : '/pedidos')
        },
        getTranslate(term, screen){
            return translate(term, screen)
        },
        goToOrder() {
           this.$router.push('/pedido') 
        }
    },
    async mounted() {
        this.$nextTick(async function() {
            await this.getAllSituations()
            setTimeout(function(){
                let el = document.getElementById(window.location.pathname)
                if(!el) el = document.getElementById('/pedidos')
                if(el) el.click()
            },160)
        })
        this.onResize()
    },

}
</script>
<style scoped>

.space-top{
    margin-top: 5em;
}
.btn1{
    text-transform: none !important;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.headerbuttons{
    /* padding-bottom: 2em; */
    position: relative;
    /* top: 22px; */
    margin-right: 4em;
    margin-top: 4em;
    display: flex;
}
.marginRight{
    margin-right: 1em;
}
.assuntoColumn{
    max-width: 200px;
}
/* .divTabs{
    height: 100%;
} */
.headerTabs{
    /* margin-bottom: 2%; */
    margin-right: 8px;
    margin-left: 8px;
    width: 89%;
    position: relative;
    /* top: 25px; */
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    bottom: 0.3em;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
    margin-right: 8px;
    margin-left: 8px;
}
.tabStyle{
    font-weight: bolder;
    display: grid;
    position: relative;
    top: 4px;
}
.tab{
    display: flex;
    position: relative;
}
.tabFont{
    font-size:13px; 
    font-weight: bolder;
}
.badge{
    position: absolute;
    right: -14px;
    top: -8px;
    background-color: #d93025;
    width: min-content;
    height: 14px;
    border-radius: 50px;
    min-width: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.badge > span{
    font-size: 10px;
    position: relative;
    left: .8px;
    color: white;
    padding: 2px;
}
.v-tabs-slider-wrapper{
    height: 5px;
}

.header-customized >>> .header{
    max-height: none !important;
}


.headerItemsResponsive{
    margin-bottom: 1em;
}

@media only screen and (max-width: 539px){
    .btn1{
        display: none;
    }
    .assuntoColumn{
        max-width: 40px;
    }
    .headerItemsResponsive{
        display: flex;
    }
}
@media only screen and (min-width: 540px) and (max-width: 739px){
    .assuntoColumn{
        max-width: 100px;
    }
    .headerItemsResponsive{
        display: flex;
    }
    .titlePage{
        margin-right: 2em;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .assuntoColumn{
        max-width: 160px;
    }
    .headerItemsResponsive{
        display: flex;
    }
    .titlePage{
        margin-right: 2em;
    }
}
/* @media only screen and (min-width: 821px) and (max-width: 1380px){
    .headerbuttons{
        top: 32px !important;
    }
    .headerTabs{
        top: 30px !important;
    }
    .borderBottomTabs{
        top: 90px !important;
    }
} */
@media only screen and (min-height: 780px) and (max-height: 850px){
    .container-page-body-space >>> body{
        margin-top: 4rem;
    }
}
@media only screen and (min-height: 851px) and (max-height: 921px){
    .container-page-body-space >>> body{
        margin-top: 3rem;
    }
}
@media only screen and (min-height: 922px) and (max-height: 992px){
    .container-page-body-space >>> body{
        margin-top: 2rem;
    }
}
</style>
